import { Paperclip, Download, Trash2, FileText } from "lucide-react";
import { API_BASE } from "../../lib/api";
import { cn } from "../../lib/utils";

export default function AttachmentsSection({ attachments, uploading, upload, deleteAttachment, onPreview }) {
  return (
    <div data-testid="panel-attachments">
      <label data-testid="attachment-upload-label" className={cn("flex items-center justify-center gap-2 h-10 rounded-md border border-dashed border-border text-sm text-muted-foreground hover:text-[#E31E24] hover:border-[#E31E24] transition-colors cursor-pointer mb-3", uploading && "opacity-50")}>
        <Paperclip size={15} />{uploading ? "Uploading…" : "Upload a file"}
        <input data-testid="attachment-upload-input" type="file" className="hidden" onChange={upload} disabled={uploading} />
      </label>
      <div className="space-y-1.5">
        {attachments.length === 0 && <p className="text-sm text-muted-foreground">No files attached.</p>}
        {attachments.map((a) => (
          <div key={a.id} data-testid={`attachment-${a.id}`} className="flex items-center gap-2 p-2 rounded-md border border-border group">
            {a.content_type?.startsWith("image/") ? (
              <button data-testid={`attachment-preview-${a.id}`} onClick={() => onPreview(a)} className="shrink-0" title="Preview image">
                <img src={`${API_BASE}/files/${a.storage_path}`} alt={a.filename} className="h-10 w-10 rounded object-cover border border-border hover:opacity-85 transition-opacity" />
              </button>
            ) : a.content_type === "application/pdf" ? (
              <button data-testid={`attachment-preview-${a.id}`} onClick={() => onPreview(a)}
                className="h-10 w-10 rounded border border-border flex items-center justify-center text-[#E31E24] hover:bg-[#E31E24]/5 transition-colors shrink-0" title="Preview PDF">
                <FileText size={15} />
              </button>
            ) : (
              <Paperclip size={14} className="text-muted-foreground shrink-0" />
            )}
            <div className="flex-1 min-w-0">
              <p className="text-sm truncate">{a.filename}</p>
              <p className="text-[10px] text-muted-foreground">{(a.size / 1024).toFixed(1)} KB · {a.uploaded_by_name}</p>
            </div>
            <a data-testid={`attachment-download-${a.id}`} href={`${API_BASE}/files/${a.storage_path}`} target="_blank" rel="noreferrer"
              className="h-6 w-6 flex items-center justify-center rounded text-muted-foreground hover:text-foreground"><Download size={13} /></a>
            <button data-testid={`attachment-delete-${a.id}`} onClick={() => deleteAttachment(a)}
              className="h-6 w-6 hidden group-hover:flex items-center justify-center rounded text-muted-foreground hover:text-[#E31E24]"><Trash2 size={13} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
